// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useEffect } from "react";
import { Table, message } from "antd";
import { RouteComponentProps } from "@reach/router";
import PageTitle from "../../../components/PageTitle";
import PageHeader from "../../../components/PageHeader";
import PageBody from "../../../components/PageBody";
import { useTranslation } from "react-i18next";
import { useStore } from "effector-react";
import { ProfilesRightsStore } from "../../../../state/profiles/ProfilesStore";
import {
  NboFeature,
  ProfileRightsListDto
} from "../../../../api/backend-openapi";
import { requestGetProfilesRights } from "../../../../state/profiles/ProfilesEffects";
import { SpinIcon } from "../../../components/SpinIcon";
import { ProfilesListColumns } from "./ProfilesListColumns";
import { setProfileRightsList } from "../../../../state/profiles/ProfilesEvents";

const ProfileListScreen: React.FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();

  const profilesRightsStore: ProfileRightsListDto | null = useStore(
    ProfilesRightsStore
  );

  // call get profiles on page load
  useEffect(() => {
    requestGetProfilesRights({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return requestGetProfilesRights.done.watch(({ result }) => {
      if (!result.ok || !result.data) {
        message.error(t("profile_list.load_failed"));
      } else {
        setProfileRightsList(result.data);
      }
    });
  });

  const profilesRights = profilesRightsStore
    ? Object.keys(profilesRightsStore).map(
        key => profilesRightsStore[key].rights
      )
    : [];

  const profilesFeatures: NboFeature[][] = profilesRights.map(
    rights => (Object.keys(rights) as unknown) as NboFeature[]
  );

  const features = profilesFeatures.reduce((acc, cur) => {
    return [...new Set([...acc, ...cur])];
  }, []);

  return (
    <>
      <PageHeader>
        <PageTitle title={t("profile_list.title")} />
      </PageHeader>

      <PageBody className="list-body">
        {
          <>
            <div className="d-flex flex-column align-items-stretch flex-sm-row">
              <div className="w-100 d-flex align-items-center">
                {profilesRightsStore && (
                  <Table
                    style={{ whiteSpace: "break-spaces" }}
                    locale={{ emptyText: profilesRightsStore ? "" : " " }}
                    loading={{
                      spinning: !profilesRightsStore,
                      indicator: SpinIcon
                    }}
                    columns={ProfilesListColumns(features)}
                    dataSource={
                      profilesRightsStore
                        ? Object.keys(profilesRightsStore).map(
                            key => profilesRightsStore[key]
                          )
                        : []
                    }
                    showSorterTooltip={false}
                    pagination={false}
                  />
                )}
              </div>
            </div>
          </>
        }
      </PageBody>
    </>
  );
};

export default ProfileListScreen;
